import { render, staticRenderFns } from "./IndagineEpidemiologicaMalattiaJakobCreutzfeldViewComponent.vue?vue&type=template&id=7495104e"
import script from "./IndagineEpidemiologicaMalattiaJakobCreutzfeldViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaMalattiaJakobCreutzfeldViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports